import { memo, useCallback, useState, useEffect } from "react";
import Form from "../../components/Form";
import { getOwners, createOrder, checkLambSlug } from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select.js";
import Spinner from "../../components/Spinner";
import { Box, Typography } from "@mui/material";
import AddOrderAnimalForm from "../../components/forms/AddOrderAnimalForm.js";
import OrderExecutionPopup from "../../components/popups/OrderExecutionPopup.js";
import { BackButton } from "../../components/Buttons.js";

const CreateOrder = () => {
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [buyerInfo, setBuyerInfo] = useState();
    const [selectedBuyer, setSelectedBuyer] = useState();
    const [sellerInfo, setSellerInfo] = useState();
    const [orderAnimals, setOrderAnimals] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const classes = useSelectStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners);
                const dropdownValues = owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
                }));
                dropdownValues.push({
                    value: "Άλλη",
                    text: "Άλλη"
                });
                setOwnersDropdownValues(dropdownValues);
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        }
    )

    useEffect(() => {
        fetchData();
    }, []);

    const ownerBuyerFormContent = [
        {
            customType: "dropdown",
            id: "buyerOwner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή Αγοραστή",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Επόμενο",
        },
    ]

    const handleBuyerSubmit = (values) => {
        setSelectedBuyer(fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.buyerOwner));
        setStep(2);
    }

    const buyerFormContent = [
        {
            customType: "input",
            id: "buyerLastName",
            type: "text",
            placeholder: "Επίθετο Αγοραστή",
            required: true,
            value: selectedBuyer?.lastName || null,
        },
        {
            customType: "input",
            id: "buyerFirstName",
            type: "text",
            placeholder: "Όνομα Αγοραστή",
            required: true,
            value: selectedBuyer?.firstName || null,
        },
        {
            customType: "input",
            id: "address",
            type: "text",
            placeholder: "Διεύθυνση Αγοραστή",
            value: selectedBuyer?.address || null,
        },
        {
            customType: "input",
            id: "city",
            type: "text",
            placeholder: "Πόλη Αγοραστή",
            required: true,
            value: selectedBuyer?.city || null,
        },
        {
            customType: "input",
            id: "county",
            type: "text",
            placeholder: "Νομός Αγοραστή",
            value: selectedBuyer?.county || null,
        },
        {
            customType: "input",
            id: "postalCode",
            type: "text",
            placeholder: "Ταχυδρομικός Κώδικας Αγοραστή",
            value: selectedBuyer?.postalCode || null,
        },
        {
            customType: "input",
            id: "phoneNumber",
            type: "text",
            placeholder: "Τηλέφωνο Αγοραστή",
            value: selectedBuyer?.phoneNumber || null,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Επόμενο",
        },
    ]

    const handleBuyerInfoSumbit = (values) => {
        setBuyerInfo(values);
        setStep(3);
    }

    const sellerForm = [
        {
            customType: "dropdown",
            id: "saleOwner",
            items: ownersDropdownValues.slice(0, -1),
            placeholder: "Εκτροφή Πωλητή",
            required: true,
        },
        {
            customType: "date-picker",
            id: "orderDate",
            type: "desktop",
            label: "Ημ/νία παραγγελίας",
            width: "595px",
            background: "third",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Επόμενο",
        },
    ]

    const handleSellerInfoSubmit = (values) => {
        values.saleOwner = fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.saleOwner)
        setSellerInfo(values);
        setStep(4);
        console.log(buyerInfo, sellerInfo)
    }

    const handleAnimalsSubmit = async (animals) => {
        setIsLoading(true);
        var animalsAdded = []
        const lambSlugs = animals
            .filter((animal) => animal.type === "Αμνός")
            .map((animal) => animal.input1);

        if (lambSlugs.length !== 0 && selectedBuyer) {
            const { success: scs, message } = await checkLambSlug(selectedBuyer._id, lambSlugs)
            if (scs) {
                for (const animal of animals) {
                    if (animal.type === "Αμνός") {
                        animalsAdded.push({
                            type: "lamb",
                            code: animal.code,
                            lambFlockCode: animal.input1,
                            orderValue: animal.input2,
                        })
                    } else {
                        animalsAdded.push({
                            type: animal.type === "Προβατίνα" ? "femaleAnimal" : "maleAnimal",
                            code: animal.code,
                            orderValue: animal.input1,
                        })
                    }
                }
                setOrderAnimals(animalsAdded);
                setIsPopupOpen(true)
            } else {
                error(message);
            }
        } else {
            for (const animal of animals) {
                if (animal.type === "Αμνός") {
                    animalsAdded.push({
                        type: "lamb",
                        code: animal.code,
                        lambFlockCode: animal.input1,
                        orderValue: animal.input2,
                    })
                } else {
                    animalsAdded.push({
                        type: animal.type === "Προβατίνα" ? "femaleAnimal" : "maleAnimal",
                        code: animal.code,
                        orderValue: animal.input1,
                    })
                }
            }
            setOrderAnimals(animalsAdded);
            setIsPopupOpen(true)
        }
        setIsLoading(false);
    }

    const onExecuted = (values) => {
        orderSubmition(true, values.executionDate)
    }

    const onNotExecuted = () => {
        orderSubmition(false, null)
    }


    const orderSubmition = async (executed, executionDate) => {
        setIsLoading(true);
        const valuesToSend = {
            buyer: selectedBuyer ? selectedBuyer?._id : null,
            buyerInfo,
            seller: sellerInfo.saleOwner._id,
            orderDate: sellerInfo.orderDate,
            animals: orderAnimals,
            executed,
            executionDate
        }

        const { success: scs, message } = await createOrder(valuesToSend);
        if (scs) {
            success(message);
        } else {
            error(message);
        }
        setStep(1);
        setIsPopupOpen(false);
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            <OrderExecutionPopup
                isOpen={isPopupOpen}
                title={"Εκτέλεση παραγγελίας"}
                onClose={() => setIsPopupOpen(false)}
                innerText={
                    <>
                        Εάν η παραγγελία έχει εκτελεστεί, εισάγετε την ημερομηνία εκτέλεσης και πατήστε <strong>ΟΚ</strong>.<br />
                        Εάν η παραγγελία δεν έχει εκτελεστεί, πατήστε <strong>Δεν έχει εκτελεστεί</strong>.<br />
                        Μπορείτε οποιαδήποτε στιγμή να ολοκληρώσετε την εκτέλεση της παραγγελίας.
                    </>
                }
                onExecuted={onExecuted}
                onNotExecuted={onNotExecuted}
            />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    {step === 1 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Επιλέξτε την Εκτροφή του Αγοραστή"}
                            </Typography>
                            <Form
                                content={ownerBuyerFormContent}
                                onSubmit={handleBuyerSubmit} />
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Εισάγετε τα στοιχεία του Αγοραστή"}
                            </Typography>
                            <Form
                                content={buyerFormContent}
                                onSubmit={handleBuyerInfoSumbit} />
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                {"Εισάγετε την Εκτροφή του Πωλητή και την ημερομηνία παρραγελίας"}
                            </Typography>
                            <Form
                                content={sellerForm}
                                onSubmit={handleSellerInfoSubmit} />
                        </>
                    )}
                    {step === 4 && (
                        <>
                            {console.log(selectedBuyer, buyerInfo, sellerInfo)}
                            <AddOrderAnimalForm onSubmit={handleAnimalsSubmit} ownerId={sellerInfo.saleOwner._id} sellerInfo={sellerInfo?.saleOwner} buyerInfo={buyerInfo} />
                        </>
                    )}
                    {step !== 1 && (
                        <BackButton onClick={() => setStep(step - 1)} />
                    )}
                </Box>
            </Box>
        </>
    )
};

export default memo(CreateOrder);